import { ReactElement } from 'react'
import { IconProps } from '../icons'

const Arrow = ({
  height = '14',
  width = '16',
  hardcodedColor = 'white',
  color,
  ...props
}: IconProps): ReactElement => {
  const fill = hardcodedColor && !color ? hardcodedColor : 'currentColor'

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 -2 ${width} ${height}`}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8 11.0084L8 0.995851C8 0.12746 6.7735 -0.332253 6.07298 0.280688L0.350407 5.18498C-0.116802 5.5937 -0.116802 6.20658 0.350407 6.56435L6.07298 11.6728C6.77359 12.3366 8 11.9278 8 11.0084Z" />
    </svg>
  )
}

export default Arrow
